import { useEffect, useState, type ReactNode } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

export function DeviceInspector({ console: consolePanel, events, network, stats, footer, className,
  defaultTab, onStatsActiveChange,
}: {
  console?: ReactNode;
  events?: ReactNode;
  network?: ReactNode;
  stats?: ReactNode;
  footer?: ReactNode;
  className?: string;
  defaultTab?: "console" | "stats";
  onStatsActiveChange?: (active: boolean) => void;
}) {
  const [tab, setTab] = useState<string>(defaultTab ?? (consolePanel ? "console" : "stats"));
  useEffect(() => { onStatsActiveChange?.(tab === "stats"); }, [tab, onStatsActiveChange]);
  const panels = [
    { id: "console", title: "Console", content: consolePanel },
    { id: "events", title: "Events", content: events },
    { id: "network", title: "Network", content: network },
    { id: "stats", title: "Stats", content: stats },
  ].filter(panel => panel.content);
  return <Tabs value={tab} onValueChange={setTab} className={cn("flex min-h-0 flex-col", className)}>
    <TabsList aria-label="Inspector tools"
      className="h-10 w-full shrink-0 justify-start rounded-none border-b bg-background px-3 py-0">
      {panels.map(panel => <TabsTrigger key={panel.id} value={panel.id}
        className="h-10 rounded-none border-b-2 border-transparent px-3 py-0 text-sm font-normal data-[state=active]:border-foreground data-[state=active]:bg-background data-[state=active]:font-medium data-[state=active]:shadow-none">
        {panel.title}
      </TabsTrigger>)}
    </TabsList>
    {/* Tool changes preserve captures, recording state, and measurement history. */}
    {panels.map(panel => <TabsContent key={panel.id} value={panel.id} forceMount
      className="m-0 flex min-h-0 flex-1 flex-col overflow-hidden data-[state=inactive]:hidden">
      {panel.content}
    </TabsContent>)}
    {footer && <div className="flex min-h-11 shrink-0 items-center border-t px-3">{footer}</div>}
  </Tabs>;
}
